export default {
  SET_SELECTED_THEME: 'setSelectedTheme',
  SET_FIELD_TENANTS: 'setFieldTenants',
}